import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizModal, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/coach') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('coachProcess', record)
        } else {
            record = Session.get('coachProcess') || {}
        }
    }
    return record
}

class CoachProcess extends WizContainer {

    componentName = 'CoachProcess'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/coachProcessList',
            payload: {
                key: 'coachProcessList@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onBtn = (type, record) => {
        const { processContentId } = this.state.record
        switch (type) {
            case 'send':
                this.jumpPage('push', '/integrationCounseling/manager/coach/send', { processContentId, ...record })
                break
            case 'look':
                this.jumpPage('push', '/integrationCounseling/manager/coach/look', { processContentId, ...record })
                break
        }
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmCoachProcess',
                    payload: {
                        key: 'confirmCoachProcess@' + processContentId,
                        apiParams: {
                            tutorContentId: processContentId
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    render() {
        let { list, counselingProcessLoading } = this.props
        let { record } = this.state
        let { processContentState } = record
        let row = list && list.data && list.data.length ? list.data[0] || {} : {}
        let columns = [{
            title: '执行内容',
            name: 'content',
            dataIndex: 'content'
        }, {
            title: '辅导日期',
            name: 'tutorDate',
            dataIndex: 'tutorDate',
            align: 'center'
        }, {
            title: '通知时间',
            name: 'noticeDate',
            dataIndex: 'noticeDate',
            align: 'center'
        }, {
            title: '签收时间',
            name: 'signDate',
            dataIndex: 'signDate',
            align: 'center'
        }, {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            align: 'center',
            render: (v) => {
                switch (v) {
                    case 1:
                        return '待下发'
                    case 2:
                        return '待签收'
                    case 3:
                        return '已签收'
                    default:
                        return ''
                }
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 220,
            render: (v, r, i) => {
                let { state } = r
                return (
                    <WizButton.Group>
                        <WizButton type='link' disabled={processContentState !== 0} onClick={() => this._onBtn('send', r)}>
                            {state === 1 ? '下发' : '重新下发'}
                        </WizButton>
                        <WizButton type='link' disabled={state === 1} onClick={() => this._onBtn('look', r)}>
                            {'查看'}
                        </WizButton>
                    </WizButton.Group>
                )
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='辅导'>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15 }}
                        disabled={processContentState !== 0 || row.state !== 3}
                        onClick={() => this._onConfirm()}>
                        {'达标确认'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'coachProcessList@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmCoachProcess@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(CoachProcess)


